import React from "react";
import Checkbox from "@source/components/UI/buttons/checkbox/checkbox";
import Radio from "@source/components/UI/buttons/radio/radio";
import TextInput from "@source/components/UI/inputs/textInput/textInput";
import {ConsentTemplateInput, ConsentTemplateInputType} from "@source/api/models/consentModels";
import styles from "./consentSteps.module.scss";

export const TemplateInput = ({input, value, disabled, error, onChange}: {
  input: ConsentTemplateInput;
  value: unknown;
  disabled: boolean;
  error?: string;
  onChange: (value: unknown) => void;
}) => {
  const fieldId = `consent-field-${input.id}`;
  if (input.type === ConsentTemplateInputType.TEXT) {
    return <div id={fieldId}>
      <TextInput
        id={`consent-input-${input.id}`}
        className={`${styles.formControl} ${styles.templateTextInput}`}
        label={input.label}
        value={typeof value === "string" ? value : ""}
        multiline={input.multiline}
        disabled={disabled}
        error={error}
        touched={Boolean(error)}
        handleChange={(event) => onChange(event.target.value)}
      />
    </div>;
  }
  if (input.type === ConsentTemplateInputType.CHECKBOX) {
    return <div id={fieldId}>
      <Checkbox
        className={styles.templateBooleanInput}
        name={`consent-input-${input.id}`}
        value={input.id}
        checked={value === true}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        label={input.label}
      />
    </div>;
  }
  if (input.type === ConsentTemplateInputType.RADIO) {
    return <div id={fieldId} className={styles.inputGroup}>
      <strong>{input.label}</strong>
      {(input.options || []).map((option) => <Radio
        key={option.id}
        name={`consent-input-${input.id}`}
        value={option.id}
        checked={value === option.id}
        disabled={disabled}
        onChange={() => onChange(option.id)}
        label={option.label}
      />)}
      {error ? <p className={styles.fieldError}>{error}</p> : null}
    </div>;
  }
  const checked = Array.isArray(value) ? value : [];
  return <div id={fieldId} className={styles.inputGroup}>
    <strong>{input.label}</strong>
    {(input.options || []).map((option) => <Checkbox
      key={option.id}
      name={`consent-input-${input.id}-${option.id}`}
      value={option.id}
      checked={checked.includes(option.id)}
      disabled={disabled}
      onChange={() => onChange(checked.includes(option.id) ? checked.filter((id: string) => id !== option.id) : [...checked, option.id])}
      label={option.label}
    />)}
  </div>;
};
